module.exports = __webpack_public_path__ + "static/media/C10.afa51a0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C10.mp4
// module id = DAfK
// module chunks = 8